export default "__VITE_ASSET__b9df52a3__"